<template>
    <div class="bulletin">
        <div class="h2"> {{ $t('activity.service_title') }}</div>
        <div class="h3">2024-01-06 10:28:37</div>
        <p> {{ $t('activity.service_h2') }}：</p>
        <p>
            {{ $t('activity.service_text') }}
            <span @click="open" class="orange">
                {{ $t('activity.service') }}
            </span>
            {{ $t('activity.consult') }}。
        </p>

        <div class="name">{{ $t('common.jgz_team') }}</div>
    </div>
</template>

<script>
export default {
    name: 'kyc',
    data() {
        return {
            loading: true
        }
    },
    mounted() {
    },
    methods: {
        open() {
            window.open('https://mos.me/cHqxfLASYVE');
        }
    }
}
</script>

<style lang='less'>
.bulletin {
    padding: 30px;
}

.h2 {
    font-size: 32px;
    font-weight: 600;
    text-align: left;
}

.h3 {
    margin: 20px 0 40px 0;
    font-size: 26px;
    text-align: left;
    color: #999;
}

p {
    text-align: left;
    line-height: 60px;
    font-size: 28px;
}

.orange {
    color: #FFA41F;
}

.name {
    margin-top: 60px;
    text-align: right;
    font-size: 28px;
}
</style>